function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M166.9 189.6l13.4 4.5 7.9-23.5-7.1-21.2 6.3-18.9L174 126l-7.8 23.4 7 21.2-6.3 19zM138.5 126l-7.8 23.4 7.1 21.2-6.3 19 13.4 4.5 7.8-23.5-7-21.2 6.3-18.9-13.5-4.5zm-21.9 4.5l-13.5-4.5-7.8 23.4 7.1 21.2-6.4 19 13.5 4.5 7.8-23.5-7.1-21.2 6.4-18.9zm139 124.6V119.7l14.7 7.7 13.2-25-141.8-74.1L0 102.4l13.2 25 14.7-7.7v135.4h227.7zm-28.4-28.2H56.4v-122l85.3-44.6 85.3 44.6.2 122z"
})));